import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_CONSTANT } from './api.constant';
import * as _ from 'lodash';
import {ApiService} from './api.service';

@Injectable()
export class AuthenticationService {

  constructor(
    private http: HttpClient,
    private apiService: ApiService) {}

  login(username: string, password: string) {
    return this.http.post(API_CONSTANT.login, {
      username: username,
      password: password
    });
  }

  requestOtp(email: string) {
    return this.http.post(API_CONSTANT.request_otp, {
      email: email,
    });
  }

  validateOTP(password: string) {
    return this.http.post(API_CONSTANT.validate_otp, {
      password: password,
    });
  }

  updateUserInfo(user){
    localStorage.setItem('userID', _.get(user, 'id'));
    localStorage.setItem('username', _.get(user, 'username'));
    localStorage.setItem('firstName', _.get(user, 'first_name'));
    localStorage.setItem('lastLame', _.get(user, 'last_name'));
    localStorage.setItem('isSuperUser', _.get(user, 'is_superuser'));
    localStorage.setItem('group', _.get(user, 'group'));
  }

  reloadUserInfo() {
    if (this.isLoggedIn()) {
      this.apiService.getMe().subscribe(
        (user: any) => {
          this.updateUserInfo(user);
        }
      );
    }
  }

  isLoggedIn() {
    return localStorage.getItem('currentUser') != null;
  }

  isAdmin() {
    return localStorage.getItem('group') === 'Admin' || localStorage.getItem('isSuperUser') === 'true';
  }

  isAccountant() {
    return localStorage.getItem('group') === 'Accountant';
  }

  isAccountantAdmin() {
    return localStorage.getItem('group') === 'Accountant Admin';
  }

  isIT() {
    return localStorage.getItem('group') === 'IT';
  }

  isCallCenter() {
    return localStorage.getItem('group') === 'Call Center';
  }

  isUIH() {
    return localStorage.getItem('group') === 'UIH';
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/services/authentication.service.ts